import { getApiUrl } from "../utils/get-api-url";

export const getContacts = async () => {
  const programConfigID = ENV_INFO.programConfigID;
  const apiUrl = getApiUrl("pxprogram2");
  const fullUrl = `${apiUrl}/programs/${programConfigID}/contacts`;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include"
  });

  const parsed = await response.json();

  if (!response.ok) {
    throw response.statusText;
  } else {
    return parsed;
  }
};
